export enum VideoLayout {
  LAYOUT1 = 'video_layout1',
  LAYOUT2 = 'video_layout2',
}
